module.exports = __webpack_public_path__ + "img/logo_pierre.6a3f1e75.jpg";